import { InscriptionState } from '../stores/inscription.slice';
import { useAppSelector } from './store.hook';

export function useInscriptionState() {
  return useAppSelector<InscriptionState>(s => s.inscription);
}